import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { GestaoUsuarioBackofficeService } from './gestao-usuario-backoffice.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-gestao-usuario-backoffice',
  templateUrl: './gestao-usuario-backoffice.component.html',
  styleUrls: ['./gestao-usuario-backoffice.component.scss']
})
export class GestaoUsuarioBackofficeComponent implements OnInit {

  public formGestaoUserBack = null;
  public rowData: any = [];
  public tableLimit = 20;
  public tipo = null;
  public customLogin = null;


  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  activatedRoute: ActivatedRoute;

  constructor(
    private formBuilder: FormBuilder,
    private service: GestaoUsuarioBackofficeService,
    private datatableService: DatatableService,
    private router: Router,
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private paginationService: SpringDatatablePaginationService,
    private dateUtilService: DateUtilService,
    private encriptyService: EncriptyUtilService,

  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.tipo = [
      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },
      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },

    ];


  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom)

    this.formGestaoUserBack = this.formBuilder.group({
      nome: [null],
      login: [null],
      status: [null],

    });

  }

  buscarUser(data: any, page?: any) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    if (page && page != null) {
      params = params.append('page', page);
    }

    if (data.nome != null) {
      params = params.append('nome', data.nome)
    }
    if (data.status != null) {
      params = params.append('status', data.status)
    }
    if (data.login != null) {
      params = params.append('login', data.login)
    }

    this.spinnerService.show();

    this.service.findByNomeOrStatus(params, (response => {
      this.rowData = response.content
      this.spinnerService.hide();
      this.paginationService.setInfo(response);
    }), (error) => this.spinnerService.hide());


  }

  gotoCadastrar() {

    this.router.navigate(['/pages/backoffice/cadastro-usuario-backoffice']);

  }

  gotoEdit(data) {

    let id = this.encriptyService.encriptyBySecretKey('' + data.id)

    let params = {

      'id': id,

    }

    this.router.navigate(['/pages/backoffice/alteracao-usuario-backoffice'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  gotoLimpar() {

    this.formGestaoUserBack = this.formBuilder.group({
      nome: [null],
      login: [null],
      status: [null],

    });

    this.datatablePagination.rowData = [null];
    this.datatablePagination.totalElements = 0;

  }


  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
